module.exports = __webpack_public_path__ + "static/media/arrival-icon.59e44835.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/arrival-icon.svg
// module id = 727
// module chunks = 0